// Shared sidebar and document activity state.
import { createContext, useContext } from "react";

export const SidebarContext = createContext({
  collapsed: false,
  setSidebarCollapsed: () => {},
  isActivelyEditing: false,
  setIsActivelyEditing: () => {}, 
  isProcessing: false,
  setIsProcessing: () => {},
  processingDocId: null,
  setProcessingDocId: () => {}
});

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  const { collapsed, isActivelyEditing, isProcessing, processingDocId, setIsActivelyEditing, setIsProcessing, setProcessingDocId } = context;
  return { sidebarCollapsed: collapsed, isActivelyEditing, isProcessing, processingDocId, setIsActivelyEditing, setIsProcessing, setProcessingDocId };
};
